import { render, staticRenderFns } from "./SubItensContrato.vue?vue&type=template&id=62dc4066"
import script from "./SubItensContrato.vue?vue&type=script&lang=js"
export * from "./SubItensContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports